import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Container, Paper, Title, Button } from '@mantine/core';
import { authApi } from '@modules/auth/api/auth.api';
import { authUtils } from '@shared/utils/axios-instance';
import { Alert, ControlledInput } from '@shared/ui';
import './LoginPage.css';

interface LoginFormData {
  email: string;
  password: string;
}

const loginSchema = yup.object({
  email: yup
    .string()
    .required('Email обязателен')
    .email('Некорректный email'),
  password: yup
    .string()
    .required('Пароль обязателен')
    .min(6, 'Пароль должен быть не менее 6 символов'),
});

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Убираем автоматический редирект - пусть ProtectedRoute сам решает
  // Это предотвращает циклы редиректов когда токен невалидный

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const onSubmit = async (data: LoginFormData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await authApi.login(data);

      // Сохраняем access токен в localStorage
      authUtils.setAccessToken(response.access_token);

      // Редиректим на главную страницу
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Ошибка входа. Проверьте email и пароль.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size={420} className="login-container">
      <Paper shadow="md" p={30} radius="md" withBorder>
        <Title order={2} ta="center" mb="md">
          Вход в админ-панель
        </Title>

        {error && (
          <Alert tone="error" mb="md">
            {error}
          </Alert>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <ControlledInput
            name="email"
            control={control}
            error={errors.email}
            label="Email"
            placeholder="your@email.com"
            type="email"
            mb="md"
          />

          <ControlledInput
            name="password"
            control={control}
            error={errors.password}
            label="Пароль"
            placeholder="Ваш пароль"
            type="password"
            mb="md"
          />

          <Button type="submit" fullWidth loading={loading}>
            Войти
          </Button>
        </form>
      </Paper>
    </Container>
  );
}

